import { PageSettings } from "./pageSettings"

/**
 * The number of milliseconds to wait before making the initial session
 * configuration request.
 */
export function getSessionConfigDelay(
  defaultValueInMilliseconds: number,
  pageSettings: PageSettings,
): number {
  return typeof pageSettings.sessionConfigDelay === "number"
    ? pageSettings.sessionConfigDelay
    : defaultValueInMilliseconds
}

export function getSessionConfigURL(pageSettings: PageSettings) {
  const sessionConfigOrigin = pageSettings.sessionConfigOrigin
    ? pageSettings.sessionConfigOrigin
    : "https://doppler-tasks.cbsivideo.com"
  return `${sessionConfigOrigin}/sessionconfig-v2.json`
}
